import css from "standard/css";

const style = css`
  .recommendation {
    margin: 0 auto; 
    max-width: 1440px; 
    display: flex;
    flex-direction: row;
    align-items: center;
    min-height: 330px;
  }

  .recommendation__aside {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: var(--spacing_inset-sm);
    padding: 0 var(--spacing-xs);
  }

  @media(width >= 1029px) {
    .recommendation__aside {
      padding: 0 var(--spacing-giant);
    }
  }

  .recommendation__stars {
    display: flex; 
    flex-direction: column; 
    gap: var(--spacing_inset-xs); 
    height: auto; 
    align-items: center; 
    width: inherit;
  }

  .recommendation__description {
    color: var(--color-master-lighter);
    display: inline-flex;
    font-family: var(--font-family-base);
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-bold);
    line-height: var(--line-height-lg);
    text-align: center;
    text-transform: inherit;
  }

  .recommendation__figure {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: var(--spacing_inset-xs);
    height: auto;
    justify-content: start;
    width: inherit;
  }

  .recommendation__src {
    border-radius: var(--border-radius-circular);
    height: 56px;
    width: 56px;
  }

  .recommendation__figcaption {
    align-items: start;
    display: flex;
    flex-direction: column;
    gap: 0;
    height: auto;
    justify-content: start;
    width: inherit;
  }

  .recommendation__name {
    color: var(--color-master-lighter);
    display: inline-flex;
    font-family: var(--font-family-base);
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-bold);
    line-height: var(--line-height-lg);
    text-align: inherit;
    text-transform: inherit;
  }

  .recommendation__status {
    color: var(--color-master-lighter); 
    display: inline-flex;
    font-family: var(--font-family-base); 
    font-size: var(--font-size-xs); 
    font-weight: var(--font-weight-regular); 
    line-height: var(--line-height-lg); 
    text-align: inherit; 
    text-transform: inherit;
  }

  .recommendation__button {
    border-radius: var(--border-radius-circular);
    border: 1px solid var(--color-master-lighter);
    background-color: transparent;
    cursor: pointer;
    display: flex;
    padding: var(--spacing_inset-nano);
  }

  .recommendation__arrow {
    pointer-events: none;
    width: 16px;
    min-width: 16px;
  }
`;

export default style;
